import { useEffect } from "react";
import { useGifQuery } from "@/common/queries/queries";
import { useGifStore } from "@/common/store/gifStore";
import { useUsersStore } from "@/common/store/storeUsers";
import { useNichesStore } from "@/common/store/storeNiches";

interface IUseCachedGif {
  gifId: string;
}

export const useCachedGif = ({ gifId }: IUseCachedGif) => {
  const gif = useGifStore(state => state.getGifById(gifId));
  const gifUser = useUsersStore(state => gif?.userName ? state.getUser(gif.userName) : undefined);
  const gifNiches = useNichesStore(state => gif?.niches ? state.getNiches(gif.niches) : {});

  const updateGifs = useGifStore(state => state.updateGifs);
  const updateUsers = useUsersStore(state => state.updateUsers);
  const updateNiches = useNichesStore(state => state.updateNiches);

  const { data, isLoading, error } = useGifQuery(gifId, { enabled: !gif && !!gifId });

  useEffect(() => {
    if (data) {
      const aliasPattern = new RegExp(/^\d*$/);
      const aliasId = aliasPattern.test(gifId) ? gifId : undefined;

      updateGifs([{ ...data.gif, aliasId }]);
      updateUsers(data.user ? [data.user] : []);
      updateNiches(data.niches);
    }
  }, [data]);

  return {
    gif,
    gifUser,
    gifNiches,
    isLoading,
    error,
  };
};
